import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { API_BASE_URL } from '@/lib/api';

export default function PasswordSetupPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (password.length < 6 || password !== confirmPassword) {
      setMessage(password !== confirmPassword ? 'Adgangskoderne er ikke ens' : 'Adgangskoden skal være mindst 6 tegn');
      return;
    }
    setSaving(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/guest/password-setup`, { token: params.get('token'), password });
      setMessage(response.data.message);
      setTimeout(() => navigate('/login'), 1200);
    } catch (error) {
      setMessage(error.response?.data?.detail || 'Adgangskoden kunne ikke gemmes');
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="min-h-screen bg-slate-950 px-4 py-16 text-slate-100">
      <form onSubmit={submit} className="mx-auto max-w-md space-y-4 rounded-xl border border-slate-700 bg-slate-900 p-6">
        <h1 className="text-2xl font-semibold">Opret ny adgangskode</h1>
        <p className="text-sm text-slate-400">Linket kan bruges én gang og udløber efter 30 minutter.</p>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Ny adgangskode" required
          className="w-full rounded-md border border-slate-700 bg-slate-800 px-3 py-2" />
        <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Gentag adgangskode" required
          className="w-full rounded-md border border-slate-700 bg-slate-800 px-3 py-2" />
        <Button type="submit" disabled={saving} className="w-full bg-blue-600 hover:bg-blue-500">{saving ? 'Gemmer...' : 'Gem adgangskode'}</Button>
        {message && <p className="text-sm text-slate-300" role="status">{message}</p>}
      </form>
    </main>
  );
}
